const locale = {
  SOMETHING_WENT_WRONG: 'We have encountered an issue. Please try again.',
  SOMETHING_WENT_WRONG_PLAIN: 'Something went wrong',
  ERROR: 'Oh no!',
};

export default locale;
